import { render, staticRenderFns } from "./External.vue?vue&type=template&id=5915fbb6&scoped=true&"
import script from "./External.vue?vue&type=script&lang=js&"
export * from "./External.vue?vue&type=script&lang=js&"
import style0 from "./External.vue?vue&type=style&index=0&id=5915fbb6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5915fbb6",
  null
  
)

export default component.exports